export const CountryBlocked = () => (
  <div className="h-screen flex items-center justify-center">
    <h1 className="text-xl font-semibold text-red-600">
      This service is not available in your country.
    </h1>
  </div>
);

